import { Component, Input } from '@angular/core';

import { AbstractControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'doc-validation-error-message',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './validation-error-message.component.html',
  styleUrls: ['./validation-error-message.component.scss']
})
export class ValidationErrorMessageComponent {
  @Input() classType: 'bootstrap' | 'docInput' = 'bootstrap';
  @Input() control: AbstractControl;
  @Input() error = false;
  @Input() message = 'Validation Error';
}
